import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import LoginTabset from "./loginTabset";
import "./login.css";
import { connect } from "react-redux";
import { setCurrentAdmin } from "../../actions";
import logo from "../../assets/images/brand/kido-logo.png";
import Clothesline from "./Clothesline";

// Growth-chart marks, bottom to top, like the height chart on a nursery wall.
// Each mark sits 10% higher than the one before it.
const GROWTH_MARKS = ["0M", "3M", "6M", "1Y", "2Y", "3Y", "4Y", "6Y", "8Y", "10Y"];

// Where the pin rests as the sign-in form fills up (percent of the chart).
const PIN_EMPTY = 20;
const PIN_HALF = 50;
const PIN_FULL = 90;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const greeting = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "Good morning";
  if (hour >= 12 && hour < 17) return "Good afternoon";
  return "Good evening";
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { pin: 0 };
    this.formRef = React.createRef();
    this.timers = [];
  }

  componentDidMount() {
    // Climb once on load, then re-check after the browser's autofill lands.
    this.timers.push(setTimeout(this.measureForm, 700));
    this.timers.push(setTimeout(this.measureForm, 1600));
  }

  componentWillUnmount() {
    this.timers.forEach(clearTimeout);
  }

  measureForm = () => {
    const form = this.formRef.current;
    if (!form) return;
    const email = form.querySelector("#loginEmail");
    const password = form.querySelector("#loginPassword");
    // Register tab (or anything else) doesn't move the pin.
    if (!email || !password) return;

    const filled =
      (EMAIL_PATTERN.test(email.value.trim()) ? 1 : 0) +
      (password.value.length > 0 ? 1 : 0);
    const pin = [PIN_EMPTY, PIN_HALF, PIN_FULL][filled];
    if (pin !== this.state.pin) this.setState({ pin });
  };

  render() {
    const { pin } = this.state;

    return (
      <div className="kd-login">
        <aside className="kd-login-story">
          <span className="kd-bubble kd-bubble-a" aria-hidden="true" />
          <span className="kd-bubble kd-bubble-b" aria-hidden="true" />
          <span className="kd-bubble kd-bubble-c" aria-hidden="true" />

          <img src={logo} alt="KIDO, where dreams begin" className="kd-login-logo kd-enter" />

          <div className="kd-login-copy">
            <h1 className="kd-login-headline">
              <span className="kd-line"><span>Made for</span></span>
              <span className="kd-line"><span>growing&nbsp;up.</span></span>
            </h1>
            <p className="kd-login-lede kd-enter">
              Clothes, toys and everyday things for little ones. Manage every
              order, size and stock count for KIDO from here.
            </p>
          </div>

          <p className="kd-login-footnote kd-enter">
            © {new Date().getFullYear()} KIDO admin
          </p>

          <div className="kd-growth" aria-hidden="true">
            <ol className="kd-growth-scale">
              {GROWTH_MARKS.map((mark, index) => (
                <li
                  key={mark}
                  className={
                    "kd-growth-mark" + (index * 10 <= pin ? " is-reached" : "")
                  }
                  style={{ "--i": index }}
                >
                  <span>{mark}</span>
                </li>
              ))}
            </ol>
            <span
              className={"kd-growth-pin" + (pin === PIN_FULL ? " is-full" : "")}
              style={{ bottom: `${pin}%` }}
            >
              <span className="kd-growth-pin-ring" />
            </span>
          </div>
        </aside>

        <main className="kd-login-panel">
          <div className="kd-login-hang">
            <Clothesline />
            <div
              className="kd-tag"
              ref={this.formRef}
              onInput={this.measureForm}
              onChange={this.measureForm}
            >
              <span className="kd-tag-hole" aria-hidden="true" />
              <img src={logo} alt="KIDO, where dreams begin" className="kd-login-logo-compact" />
              <h2 className="kd-login-title kd-enter">{greeting()}</h2>
              <p className="kd-login-sub kd-enter">
                Welcome back. Sign in to manage orders, stock and payments.
              </p>
              <div className="kd-enter kd-enter-late">
                <LoginTabset
                  setCurrentAdmin={this.props.setCurrentAdmin}
                  currentAdmin={this.props.currentAdmin2}
                />
              </div>
            </div>
            <p className="kd-login-access kd-enter">
              Need an account? Ask a KIDO admin to add you.
            </p>
          </div>
        </main>
        <ToastContainer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentAdmin2: state.admins.currentAdmin,
});

export default connect(mapStateToProps, { setCurrentAdmin })(Login);
